import {
  MEETING_ROOM_ALL,
  MEETING_ROOM_CREATE,
  MEETING_ROOM_DELETE,
  MEETING_ROOM_GET,
  MEETING_ROOM_UPDATE,
  MEETING_ROOM_ERROR,
} from "../../actions/types"

const initialState = {
  meetingRoom: null,
  isLoading: false,
}
export default function MeetingRoomReducers(state = initialState, action) {
  switch (action.type) {
    case MEETING_ROOM_ALL:
      return {
        arr: action.payload?.rows,
        currPage: action.payload?.currPage,
        lastPage: action.payload?.lastPage,
        isLoading: true,
      }
    case MEETING_ROOM_GET:
      return {
        ...action.payload,
        isLoading: true,
      }
    case MEETING_ROOM_CREATE:
      return { isLoading: false }
    case MEETING_ROOM_UPDATE:
      return { isLoading: false }
    case MEETING_ROOM_DELETE:
      return { isLoading: false }
    case MEETING_ROOM_ERROR:
      return { isLoading: false }
    default:
      return state
  }
}
